module.exports = "## JPEG compressor\r\n\r\nJPEG is a popular file/compression format used for storing digital images. Most JPEG files can be optimized further without losing any visual image quality. Upload and compress JPEG files above to improve page load times and save your bandwidth costs."


//////////////////
// WEBPACK FOOTER
// ./src/containers/CompressImages/jpeg-compressor.md
// module id = 1142
// module chunks = 0